import {
  hideScrollbar,
  smallLabelTypographicStyle,
} from "@/lib/styles/helpers";
import styled from "styled-components";
import { MainWrapper } from "@/lib/styles";
import { pageTop } from "@/lib/styles/helpers";

export const FormWrapper = styled(MainWrapper)`
  padding-top: 2rem;

  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.laptop} {
    ${pageTop};
    flex-direction: row;
  }
`;

export const FormNavigation = styled.ul`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 4rem;
  gap: 1rem;

  overflow: scroll;
  ${hideScrollbar}

  li + li {
    margin-left: 15px;
  }

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 340px;
    flex-direction: column;
    gap: 1.5rem;

    li + li {
      margin-left: 0;
    }
  }
`;

interface FormNavigationItemProps {
  textColor?: string;
}

export const FormNavigationItem = styled.li<FormNavigationItemProps>`
  color: ${(props) => props.textColor};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  text-decoration: none;
  ${smallLabelTypographicStyle}

  &:hover {
    color: ${({ theme }) => theme.colors.red};
  }
`;

export const FormsContainer = styled.div`
  width: 100%;
    

  ${({ theme }) => theme.mediaQueries.laptop} {
    form {
    }
  /* Change the white to any color */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
`;
